export { default } from './Dialog';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Dialog/index.js
// module id = 164
// module chunks = 0